'use client';

import * as React from 'react';
import { pathPrefixAtom } from 'app/blog/[domain]/_components/blog-state';
import { showBreadcrumbAtom } from 'app/blog/[domain]/_components/design-state';
import { IconHomeLine } from 'icon/General/home-line';
import { useAtomValue } from 'jotai';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from 'ui';

export type BreadcrumbProps = {
  title: string;
};

export function PostBreadcrumb({ title }: BreadcrumbProps): JSX.Element {
  const urlPrefix = useAtomValue(pathPrefixAtom) || '/';
  const showBreadcrumb = useAtomValue(showBreadcrumbAtom);
  if (!showBreadcrumb) {
    return <></>;
  }
  return (
    <Breadcrumb className="post-header-breadcrumb">
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink href={urlPrefix}>
            <IconHomeLine className="post-breadcrumb-home-icon" />
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />
        <BreadcrumbItem>
          <BreadcrumbLink href={`${urlPrefix}#tag-tabs`}>Post</BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />
        <BreadcrumbItem>
          <BreadcrumbPage className="post-breadcrumb-current">
            {title}
          </BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  );
}
